import { parseISO } from "date-fns";

export const formatDate = (dateString) => {
  if (!dateString) return '';
 
  try {
    const date = parseISO(dateString); 
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    const hh = String(date.getUTCHours()).padStart(2, '0');
    const min = String(date.getUTCMinutes()).padStart(2, '0');

    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  } catch (error) {
    return '';
  }
};
